module.exports = __webpack_public_path__ + "img/logo-fa-left-white.2d71ca2.svg";